import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["d"]

import { MenuComponent } from "@syncfusion/ej2-vue-navigations";
import { SogDropDownButtonType } from "@/shared/ui/types/SogDropDownButtonType";
import SogMenuItem from "@/shared/ui/types/SogMenuItem";

interface Props {
  mdiIcon?: string;
  items?: SogMenuItem[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogMenu',
  props: {
    mdiIcon: { default: "" },
    items: { default: undefined }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const _emit = __emit;

function onSelect(args: any) {
  _emit("select", args.item);
}

function onBeforeItemRender(args: any) {
  const a = document.getElementById("svg_" + args.item.id);

  const div = document.createElement("div");
  /*
    div.setAttribute("class", "sog-card-action-more-button");
  */
  div.setAttribute("style", "display:flex; ");

  if (a) {
    div.appendChild(a);
  }
  const text = document.createElement("span");
  text.innerText = args.item.text;
  div.appendChild(text);
  args.element.innerHTML = args.element.innerHTML.replace(args.item.text, "");
  args.element.appendChild(div);
  //  console.log(args.element)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items?.filter((t) => t.svgIcon), (svg) => {
      return (_openBlock(), _createElementBlock("svg", {
        id: 'svg_' + svg.id,
        key: svg,
        width: "21",
        height: "21",
        style: {"align-self":"center","margin-right":"3px"}
      }, [
        _createElementVNode("path", {
          d: svg.svgIcon
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    }), 128)),
    _createVNode(_unref(MenuComponent), {
      items: __props.items,
      select: onSelect,
      "before-item-render": onBeforeItemRender
    }, null, 8, ["items"])
  ]))
}
}

})